<script>
export default {
    props: {
        record: {
            required: true,
            type: Object
        }
    },
}
</script>
<template>
    <div class="p-1 rounded m-1">

        <div class="flex items-center border-b ">
            <div class="w-full px-1">
                <div v-if="typeof record.messages === 'object'" >
                    <project-bulk-import-result-log-message
                        :messages="record.messages ">
                    </project-bulk-import-result-log-message>
                </div>
                <div v-else>
                    <li :class="{'bg-yellow': typeof message === 'string' && message.includes('successfully') ? false : true}">
                        {{ record.messages }}
                    </li>
                </div>  
            </div>
        </div>
    </div>
</template>
